export const  onlyBeUsed="此功能只能在纳税人状态正常时使用。";
export const  no="发票数量";
export const  value="发票金额";
export const  yearly="Yearly";
export const  monthly="Monthly";
export const  weekly="Weekly";
export const  daily="Daily";
export const  ok="OK";

export const  total="合计";
export const  vat="增值税";
export const  excise="消费税";
export const  other="其他";
export const  numberNotFound="申请编号未找到！";
export const  invoiceNotExist="发票不存在";
export const  tooManyTimes="发票验证次数过多，超过了最大限制.";

export const  pendingTaskList="待处理列表";
export const  creditNote="负票";
export const  cancellationDebit="补票作废";
export const  offlineParameters="离线参数";
export const  myDashboard="我的仪表盘";
export const  statisticsType="统计分类";
export const  invoicesIssued="发票开具";
export const  taxStatistics="税额统计";
export const  menuQuickEntry="菜单导航";
export const  trackApplicationStatus="申请状态追踪";
export const  enterReferenceNumber="请输入申请编号";
export const  fiscalDocumentValidation="发票查验";
export const  numberIsRequired="发票号码必填";
export const  enterNumber="输入发票号";
export const  enterDateIssued="输入发票日期";
export const  verificationCode="验证码";
export const  deviceNumber="设备号";
export const  validate="查验";
export const  track="追踪";
export const  basicSearch="查询";
export const  advancedSearch="高级查询";
export const  accreditedSuppliers="供应商";

export const  devices="设备";
export const  softwareIntegrators="软件集成商";
export const  zReports="报表统计";
export const  document="文档";
export const  dsn="DSN";
export const  applicationSoftware="应用软件";
export const  enterFiscalDocument="输入发票号码";
export const  salesInvoices="销售发票";
export const  totalInvoiceQuantity ="发票总数量";
export const  totalInvoiceAmount="发票总金额";
export const awaiting="等待";
export const accepted="接受";
export const rejected="拒绝";
